import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  // stable row identifier the merge-button enable logic matches on; whichRecords is display-only
  rowKey: '',
  whichRecords: '',
  taxOrOwnerCount: '',
  summaryCount: '',
  commentsCount: '',
};

export const assessorMergeAndFinalizeActions = {
  async getAccessorFileMergeAndFinalize({ commit, dispatch }, {
    baseCrudKey,
  }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          getAccessorFileMergeAndFinalize {
            ${fieldsToGqlString(fields)},
      }}`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (results.data) {
        const { getAccessorFileMergeAndFinalize } = results.data;
        commit('base/crud/setItems', [baseCrudKey, getAccessorFileMergeAndFinalize], { root: true });
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting List.', { root: true });
    }
  },
  async mergeAssessorTaxRollRecordsToTaxInquiryCollection({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        // `message` is set when the merge refused to run - the tax year already has records, or
        // another merge step is still going. It is already worded for the user, so the screen
        // shows it instead of a generic "there was a problem".
        query: gql`{
          mergeAssessorTaxRollRecordsToTaxInquiryCollection { statusCode, message }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorTaxRollRecordsToTaxInquiryCollection } = results.data;
      return mergeAssessorTaxRollRecordsToTaxInquiryCollection;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return {};
  },
  async pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress { statusCode, totalRecords }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress } = results.data;
      return pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging tax/owner.', { root: true });
    }
    return { statusCode: 201 };
  },
  async mergeAssessorSummaryToTaxrollSummary({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          mergeAssessorSummaryToTaxrollSummary { statusCode, message }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorSummaryToTaxrollSummary } = results.data;
      return mergeAssessorSummaryToTaxrollSummary;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging summary.', { root: true });
    }
    return {};
  },
  async mergeAssessorCommentsToTaxComments({ commit, dispatch }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`{
          mergeAssessorCommentsToTaxComments { statusCode, message }
          }`,
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      const { mergeAssessorCommentsToTaxComments } = results.data;
      return mergeAssessorCommentsToTaxComments;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while merging comments.', { root: true });
    }
    return {};
  },
  /* Mails the county the conversion summary after Change Default Tax Year has saved the new
     year. The year change has already happened by the time this runs, so a failure here is
     reported to the caller rather than flashed as an error - see changeDefaultTaxYear in
     mergeAndFinalize.vue. */
  async sendNewTaxRollConversionSummary({ commit, dispatch }, { taxYear, newTaxRollDate } = {}) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation sendNewTaxRollConversionSummary($taxYear: Int, $newTaxRollDate: String) {
          sendNewTaxRollConversionSummary(taxYear: $taxYear, newTaxRollDate: $newTaxRollDate) {
            sent, recipients, mode, reason, taxYear, recordCount, mobileHomeRecordCount,
            mobileHomeTaxTypeCount, totalTaxAmount, reportFiles
          }
        }`,
        variables: { taxYear, newTaxRollDate },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      return (results.data && results.data.sendNewTaxRollConversionSummary) || {};
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
    }
    return { sent: false, reason: 'The summary email could not be sent.' };
  },
};

export default assessorMergeAndFinalizeActions;
